<app-section-titulo-educacao-tecnologica></app-section-titulo-educacao-tecnologica>
<app-section-projeto-educere></app-section-projeto-educere>
<app-section-aluno-a-empresario></app-section-aluno-a-empresario>
<app-section-inscricoes-abertas></app-section-inscricoes-abertas>
